import React, { useState, useEffect } from 'react'
import Reusabletable from '../reusableforms/Reusabletable'
import { uploadEmployeeMasterFile, getEmployees, updateEmployeesById, deleteEmployeesById, multiDeleteEmployeeMasterFile, uploadEmployeeDynamicUpdateFile } from './../../../../services/register_redux/register_actions/Employee.action';
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import { useDispatch, useSelector } from 'react-redux';
import files from "./../../../../assets/templates/register_template/employee_master.xlsx"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/emp_master_icon.png"
import bank_account_no_icon from "../../../../assets/register_assets/inputMatix/Emp_master/bank_account_no_icon.png"
import bank_address_icon from "../../../../assets/register_assets/inputMatix/Emp_master/bank_address_icon.png"
import bank_ifsc_icon from "../../../../assets/register_assets/inputMatix/Emp_master/bank_ifsc_icon.png"
import bank_name from "../../../../assets/register_assets/inputMatix/Emp_master/bank_name.png"
import branch_id_icon from "../../../../assets/register_assets/inputMatix/Emp_master/branch_id_icon.png"
import Client_id_icon from "../../../../assets/register_assets/inputMatix/Emp_master/Client_id_icon.png"
import companies_worked_with_icon from "../../../../assets/register_assets/inputMatix/Emp_master/companies_worked_with_icon.png"
import dob_icon from "../../../../assets/register_assets/inputMatix/Emp_master/dob_icon.png"
import designation_icon from "../../../../assets/register_assets/inputMatix/Emp_master/designation_icon.png"
import doj_icon from "../../../../assets/register_assets/inputMatix/Emp_master/doj_icon.png"
import emp_code_icon from "../../../../assets/register_assets/inputMatix/Emp_master/emp_code_icon.png"
import emp_name_icon from "../../../../assets/register_assets/inputMatix/Emp_master/emp_name_icon.png"
import esi_icon from "../../../../assets/register_assets/inputMatix/Emp_master/esi_icon.png"
import father_and_husband_icon from "../../../../assets/register_assets/inputMatix/Emp_master/father_and_husband_icon.png"
import gender_icon from "../../../../assets/register_assets/inputMatix/Emp_master/gender_icon.png"
import group_icon from "../../../../assets/register_assets/inputMatix/Emp_master/group_icon.png"
import nature_of_working_icon from "../../../../assets/register_assets/inputMatix/Emp_master/nature_of_working_icon.png"
import permanent_address_icon from "../../../../assets/register_assets/inputMatix/Emp_master/permanent_address_icon.png"
import pf_icon from "../../../../assets/register_assets/inputMatix/Emp_master/pf_icon.png"
import relay_icon from "../../../../assets/register_assets/inputMatix/Emp_master/relay_icon.png"
import postal_address_icon from "../../../../assets/register_assets/inputMatix/Emp_master/postal_address_icon.png"
import shift_no_icon from "../../../../assets/register_assets/inputMatix/Emp_master/shift_no_icon.png"
import years_of_exprience_icon from "../../../../assets/register_assets/inputMatix/Emp_master/years_of_exprience_icon.png"
import emp_main_icon from "../../../../assets/register_assets/inputMatix/Emp_master/emp_main_icon.png"
import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";
import {
    fetchEmployeeDynamicUpdateFields,
    downloadEmployeeDynamicUpdateTemplate,
} from '../../../../services/register_redux/register_api_services/Employee.api';

import { useParams } from 'react-router-dom';


function EmployeeMaster({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const { date } = useParams();
    const [createData, setCreateData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const [dynamicFields, setDynamicFields] = useState([]);
    const [selectedDynamicFields, setSelectedDynamicFields] = useState([]);
    const [dynamicEffectiveDate, setDynamicEffectiveDate] = useState(date || '');
    const [dynamicUpdateFile, setDynamicUpdateFile] = useState(null);
    const [uploadMode, setUploadMode] = useState('');
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const header = [
        { key: "emp_code", value: "Employee Code", input: "text", readOnly:true, icon: emp_code_icon, dataIcon: false, highlightName: false },
        { key: "emp_name", value: "Employee Name", input: "text", readOnly:true, icon: emp_name_icon, dataIcon: true, highlightName: false  },
        { key: "surname", value: "Surname", icon: null, dataIcon: false, highlightName: false },
        { key: "fatherOrHusband", value: "Father Or Husband", input: "text", icon: father_and_husband_icon, dataIcon: false, highlightName: false  },
        { key: "unit_id", value: "Branch ID", input: "text", input: "text" ,readOnly:true, icon: branch_id_icon, dataIcon: false, highlightName: false  },
        { key: "client_id", value: "Organization ID", input: "text",readOnly:true, icon: Client_id_icon, dataIcon: false, highlightName: false   },
        { key: "gender", value: "Gender", input: "text", icon: gender_icon, dataIcon: false, highlightName: false  },
        { key: "dob", value: "Date Of Birth", input: "date", icon: dob_icon, dataIcon: false, highlightName: false  },
        { key: "mail_id", value: "Mail Id", input: "mail", icon: emp_main_icon, dataIcon: false, highlightName: false  },
        { key: "mobile_no", value: "Mobile Number", input: "number", icon: emp_code_icon, dataIcon: false, highlightName: false  },
        { key: "aadhaar_no", value: "Aadhaar Number", input: "text", icon: Client_id_icon, dataIcon: false, highlightName: false  },
        { key: "pan_no", value: "Pan Number", input: "text", icon: emp_code_icon, dataIcon: false, highlightName: false  },
        { key: "postal_add", value: "Postal Address", icon: postal_address_icon, dataIcon: false, highlightName: false  },
        { key: "per_add", value: "Permanent Address", icon: permanent_address_icon, dataIcon: false, highlightName: false  },
        { key: "designation", value: "Designation", icon: designation_icon, dataIcon: false, highlightName: false  },
        { key: "natural_of_work", value: "Nature Of Working", icon: nature_of_working_icon, dataIcon: false, highlightName: false  },
        { key: "department", value: "Deparment", icon: designation_icon, dataIcon: false, highlightName: false  },
        { key: "emp_type", value: "Employee Type", input: "text", icon: emp_code_icon, dataIcon: false, highlightName: false  },
        { key: "doj", value: "Date Of Joining", input: "date", icon: doj_icon, dataIcon: false, highlightName: false  },
        { key: "esi_no", value: "ESI No", icon: esi_icon, dataIcon: false, highlightName: false  },
        { key: "pf_no", value: "PF No", icon: pf_icon, dataIcon: false, highlightName: false  },
        { key: "years_of_experiance", value: "Years Of Experiance", input: "text", icon: years_of_exprience_icon, dataIcon: false, highlightName: false  },
        { key: "comp_worked_with", value: "Companies Worked With", icon: companies_worked_with_icon, dataIcon: false, highlightName: false  },
        { key: "bank_Acc_No", value: "Bank Account NO", icon: bank_account_no_icon, dataIcon: false, highlightName: false  },
        { key: "bank_ifsc", value: "Bank IFSC", icon: bank_ifsc_icon, dataIcon: false, highlightName: false  },
        { key: "bank_name", value: "Bank Name", icon: bank_name, dataIcon: false, highlightName: false  },
        { key: "bank_add", value: "Bank Address", icon: bank_address_icon, dataIcon: false, highlightName: false  },
        { key: "group_emp", value: "Group", icon: group_icon, dataIcon: false, highlightName: false  },
        { key: "relay", value: "Relay", icon: relay_icon, dataIcon: false, highlightName: false  },
        { key: "shift_no", value: "Shift Number", icon: shift_no_icon, dataIcon: false, highlightName: false  },
        { key: "place_of_birth", value: "Place of Birth", icon: null, dataIcon: false, highlightName: false },
        { key: "nationality", value: "Nationality", icon: null, dataIcon: false, highlightName: false },
        { key: "eduction_level", value: "Education Level", icon: null, dataIcon: false, highlightName: false },
        { key: "categoty", value: "Category", icon: null, dataIcon: false, highlightName: false },
        { key: "promotion", value: "Promotion", icon: null, dataIcon: false, highlightName: false },
        { key: "uan", value: "UAN", icon: null, dataIcon: false, highlightName: false },
        { key: "nominee", value: "Nominee", icon: null, dataIcon: false, highlightName: false },
        { key: "detail_of_family", value: "Detail of Family", icon: null, dataIcon: false, highlightName: false },
        { key: "eps_or_nps", value: "EPS or NPS", icon: null, dataIcon: false, highlightName: false },
        { key: "service_book_no", value: "Service Book No", icon: null, dataIcon: false, highlightName: false },
        { key: "mark_of_identification", value: "Mark of Identification",input:"file", icon: null, dataIcon: false, highlightName: false },
        { key: "photo", value: "Photo",input:"file" },
        { key: "employee_signature", value: "Employee Signature",input:"file" },
        { key: "remark", value: "Remark", icon: null, dataIcon: false, highlightName: false }
    ]
    const [actionChecked, setActionChecked] = useState("");

    const getMonthBounds = (isoDate) => {
        if (!isoDate) return { start: "", end: "" };
        const [y, m] = String(isoDate).split("-").map(Number);
        if (!y || !m) return { start: "", end: "" };
        const start = `${y}-${String(m).padStart(2, "0")}-01`;
        const lastDay = new Date(y, m, 0).getDate();
        const end = `${y}-${String(m).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
        return { start, end };
    };
    const { start: effectiveMonthStart, end: effectiveMonthEnd } = getMonthBounds(date);

    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getEmployees(date));
            const data = Array.isArray(response?.data) ? response.data : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch employee master:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);


    const downloadBase64Excel = (contentBase64, filename) => {
        try {
            const byteCharacters = atob(contentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'employee_master_failed_rows.xlsx';
            a.click();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Download failed:', e);
            showSnackbar('Failed to download error file', 'error');
        }
    };

    const handleFileUpload = async () => {
        if (file) {
            setLoading(true);
            try {
                const response = await dispatch(uploadEmployeeMasterFile(file));
                if (response.success == true) {
                    const msg = response.message;
                    showSnackbar(msg.message || 'Upload completed', 'success');
                    setLoading(false);
                    fetchdata();
                    setFile(null);
                    setActionChecked("create");
                    if (msg.error_file && msg.error_file.content_base64) {
                        downloadBase64Excel(msg.error_file.content_base64, msg.error_file.filename);
                    }
                } else {
                    const err = response.message;
                    const displayError = Array.isArray(err) ? err.slice(0, 3).join('; ') + (err.length > 3 ? ` ... and ${err.length - 3} more` : '') : (err && err.error) || err || 'Upload failed';
                    showSnackbar(displayError, 'warning');
                    setLoading(false);
                }
            } catch (error) {
                showSnackbar('An error occurred', 'error');
                setLoading(false);
            }
        }
    };


    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    //             const response = await dispatch(uploadEmployeeMasterFile(file));
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message.error, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };
    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteEmployeeMasterFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {
        setLoading(true);
        try {
            const response = await dispatch(updateEmployeesById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteEmployeesById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Employee Master');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);

    useEffect(() => {
        const fetchDynamicFields = async () => {
            try {
                const response = await fetchEmployeeDynamicUpdateFields();
                setDynamicFields(response?.fields || []);
            } catch (err) {
                console.error("Failed to fetch dynamic update fields:", err);
            }
        };
        fetchDynamicFields();
    }, []);

    const toggleDynamicField = (fieldKey) => {
        setSelectedDynamicFields((prev) =>
            prev.includes(fieldKey) ? prev.filter((k) => k !== fieldKey) : [...prev, fieldKey]
        );
    };

    const handleDownloadDynamicTemplate = async () => {
        if (!selectedDynamicFields.length) {
            showSnackbar("Please select at least one field", "warning");
            return;
        }
        const chosenDate = dynamicEffectiveDate || date;
        if (effectiveMonthStart && effectiveMonthEnd && chosenDate && (chosenDate < effectiveMonthStart || chosenDate > effectiveMonthEnd)) {
            showSnackbar("Effective Date must be within the current month", "warning");
            return;
        }

        setLoading(true);
        try {
            const response = await downloadEmployeeDynamicUpdateTemplate({
                fields: selectedDynamicFields,
                effective_date: dynamicEffectiveDate || date
            });
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'employee_master_dynamic_update_template.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            showSnackbar("Dynamic template downloaded", "success");
            setSelectedDynamicFields([]);
        } catch (err) {
            showSnackbar(typeof err === 'string' ? err : "Failed to download dynamic template", "error");
        } finally {
            setLoading(false);
        }
    };

const handleDynamicUpdateUpload = async () => {
    if (!dynamicUpdateFile) {
        showSnackbar("Please choose the filled dynamic update template file", "warning");
        return;
    }
    setLoading(true);
    try {
        const result = await dispatch(uploadEmployeeDynamicUpdateFile(dynamicUpdateFile));

        if (result.success === true) {
            const msg = result.message; 
            showSnackbar(msg?.message || "Dynamic update upload completed", "success");

            setDynamicUpdateFile(null);
            fetchdata();

            if (msg?.error_file?.content_base64) {
                downloadBase64Excel(msg.error_file.content_base64, msg.error_file.filename);
            }

        } else {
            const err = result.message;

            const displayError = Array.isArray(err)? err.slice(0, 3).join('; ') + (err.length > 3 ? ` ... and ${err.length - 3} more` : '') : (err && err.error) || err || 'Upload failed';
            showSnackbar(displayError, 'warning');
        }

    } catch (err) {
        showSnackbar(
            typeof err === 'string' ? err : "Dynamic update upload failed", "error");
    } finally {
        setLoading(false);
    }
};

    const closeUpdateModal = () => {
        setIsUpdateModalOpen(false);
    };

    const openUpdateModal = () => {
        const { start, end } = getMonthBounds(date);
        const current = dynamicEffectiveDate || date || "";
        if (start && end && (current < start || current > end)) {
            setDynamicEffectiveDate(start);
        } else if (!current && start) {
            setDynamicEffectiveDate(start);
        }
        setIsUpdateModalOpen(true);
    };
    

    return (
        <div className='container-fluid'>

            {/* <Reusabletable

                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Employee Master'}
                filestemp={files}
                setLoading={setLoading}
                showSnackbar={showSnackbar}
                date={date}


            /> */}
            {createData ? (
                <div className='card mt-2 mb-3 p-3'>
                    <h6 className='mb-2'>Employee Master Upload Options</h6>
                    <div className='d-flex flex-wrap gap-4 mb-3'>
                        <label className='form-check-label'>
                            <input
                                type='radio'
                                className='form-check-input me-1'
                                name='employeeUploadMode'
                                value='new_joinee'
                                checked={uploadMode === 'new_joinee'}
                                onChange={(e) => setUploadMode(e.target.value)}
                            />
                            New Joinee Upload
                        </label>
                        <label className='form-check-label'>
                            <input
                                type='radio'
                                className='form-check-input me-1'
                                name='employeeUploadMode'
                                value='update_existing'
                                checked={uploadMode === 'update_existing'}
                                onChange={(e) => setUploadMode(e.target.value)}
                            />
                            Update Existing
                        </label>
                    </div>

                    {uploadMode === 'new_joinee' && (
                        <ImportFileformInputMatrix
                            setFiledata={setFile}
                            title={'Employee Master'}
                            filestemp={files}
                            handleFileUpload={handleFileUpload}
                            date={date}
                            File={file}
                        />
                    )}

                    {uploadMode === 'update_existing' && (
                        <div className='d-flex flex-wrap gap-2 align-items-center'>
                            <button
                                className='btn btn-outline-primary btn-sm'
                                onClick={openUpdateModal}
                            >
                                Employee Master Update
                            </button>
                            <input
                                type='file'
                                accept='.xlsx,.xls'
                                className='form-control form-control-sm'
                                style={{ maxWidth: '320px' }}
                                onChange={(e) => setDynamicUpdateFile(e.target.files?.[0] || null)}
                            />
                            <button className='btn btn-success btn-sm' onClick={handleDynamicUpdateUpload}>
                                Upload Update File
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <ImportFileformInputMatrixclientData date={date} />
            )}

            {isUpdateModalOpen && (
                <div
                    className='position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center'
                    style={{ backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 1060 }}
                >
                    <div
                        className='w-100'
                        style={{ maxWidth: '900px', margin: '0 16px' }}
                    >
                        <div
                            className='shadow'
                            style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '10px',
                                border: '1px solid #d9d9d9',
                                color: '#212529'
                            }}
                        >
                            <div className='d-flex justify-content-between align-items-center px-3 py-2 border-bottom'>
                                <h5 className='mb-0'>Employee Master Update</h5>
                                <button
                                    type='button'
                                    className='btn btn-sm btn-outline-secondary'
                                    onClick={closeUpdateModal}
                                >
                                    Close
                                </button>
                            </div>
                            <div className='px-3 py-3'>
                                <div className='mb-3'>
                                    <label className='form-label'>Effective Date</label>
                                    <input
                                        type='date'
                                        className='form-control'
                                        value={dynamicEffectiveDate || ''}
                                        min={effectiveMonthStart}
                                        max={effectiveMonthEnd}
                                        onChange={(e) => {
                                            const next = e.target.value;
                                            if (effectiveMonthStart && effectiveMonthEnd && (next < effectiveMonthStart || next > effectiveMonthEnd)) {
                                                return;
                                            }
                                            setDynamicEffectiveDate(next);
                                        }}
                                    />
                                </div>
                                <div className='mb-2'>
                                    <label className='form-label'>Select fields to update</label>
                                    <div className='d-flex flex-wrap gap-3'>
                                        {dynamicFields.map((field) => (
                                            <label key={field.key} className='form-check-label'>
                                                <input
                                                    type='checkbox'
                                                    className='form-check-input me-1'
                                                    checked={selectedDynamicFields.includes(field.key)}
                                                    onChange={() => toggleDynamicField(field.key)}
                                                />
                                                {field.label}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex justify-content-end gap-2 px-3 py-2 border-top'>
                                <button type='button' className='btn btn-primary btn-sm' onClick={handleDownloadDynamicTemplate}>
                                    Download Dynamic Template
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Employee Master'}
            data={getData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {editData}
            getDeletePermission = {deleteData}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#0057ff"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}

export default EmployeeMaster
